export default theme => ({
  title: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  formSection: {
    marginTop: theme.spacing(2),
  },
  inputField: {
    marginBottom: theme.spacing(2),
  },
  schedulerSection: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(2),
  },
  schedulerTitle: {
    marginBottom: theme.spacing(2),
  },
  schedulerEntry: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  schedulerInputs: {
    display: "flex",
    gap: theme.spacing(2),
    flex: 1,
  },
  addButton: {
    marginTop: theme.spacing(1),
  },
  deleteButton: {
    minWidth: "auto",
  },
  error: {
    marginTop: theme.spacing(1),
  },
  skyTitle: {
    marginTop: 16,
    marginBottom: 8,
  },
  schedulerInstructions: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(1),
    color: theme.palette.text.secondary,
  },
  schedulerFormat: {
    marginBottom: theme.spacing(1),
    "& ul": {
      marginTop: theme.spacing(0.5),
      marginBottom: theme.spacing(1),
      paddingLeft: theme.spacing(3),
    },
    "& li": {
      marginBottom: theme.spacing(0.5),
    },
  },
  schedulerExample: {
    marginBottom: theme.spacing(2),
    padding: theme.spacing(1),
    backgroundColor: theme.palette.grey[100],
    borderRadius: theme.shape.borderRadius,
    fontFamily: "monospace",
    fontSize: "0.85rem",
    wordBreak: "break-word",
  },
  uploadButton: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(2),
  },
  errorMessage: {
    marginTop: theme.spacing(1),
    padding: theme.spacing(1),
    backgroundColor: theme.palette.error.light,
    borderRadius: theme.shape.borderRadius,
  },
  successMessage: {
    display: "flex",
    alignItems: "center",
    marginTop: theme.spacing(1),
    padding: theme.spacing(1),
    backgroundColor: theme.palette.success.light,
    borderRadius: theme.shape.borderRadius,
  },
  successIcon: {
    marginRight: theme.spacing(1),
    color: theme.palette.success.dark,
  },
  successText: {
    color: theme.palette.success.dark,
  },
  entriesCount: {
    marginTop: theme.spacing(1),
    fontWeight: 500,
  },
});
